enum GAME_TYPE {
  Tetris = 'TETRIS',
  Zelda = 'ZELDA',
  SpaceInvaders = 'SPACE_INVADERS',
  Oryn = 'ORYN',
}

export { GAME_TYPE };
